import { req } from 'react-reqq-lite';

import { withAclReq } from 'modules/partial/hooks';

import * as c from './constants';
import { transformMerchant } from './transformer';

export const getBranchList = (merchant_uuid, params, callback = () => {}) => {
  req.get(
    withAclReq(
      () => ({
        ADMIN: {
          url: `/v1/vendors/${merchant_uuid}/branches`,
        },
        MERCHANT: {
          url: '/v1/me/branches',
        },
      }),
      {
        key: c.GET_BRANCH_LIST,
        params,
        transform: ({ data, meta, included }) => {
          const x = data?.map((item) => transformMerchant(item, included));
          return {
            data: x,
            pagination: meta?.pagination ?? {},
          };
        },
        onSuccess: (res) => {
          callback(res?.response);
        },
      }
    )
  );
};
